module.exports = __webpack_public_path__ + "img/index-pic1.a3d3460a.webp";